import React, { useState, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';
import { useAuthState, useSignOut } from 'react-firebase-hooks/auth';
import {
  get,
  child,
  ref,
  onValue,
  push,
  DataSnapshot,
} from 'firebase/database';
import { auth, db } from './firebase/config';
import LoginButton from './components/LoginButton';
import MessageHistory from './components/MessageHistory';
import MessageInput from './components/MessageInput';
import { useSetAnalytics } from '../../hooks';

export interface MusicProps {
  link?: string;
  platform?: string;
  lastUserId?: string;
}

export interface Message {
  title?: string;
  createdByName?: string;
  createdById?: string;
  createdAt?: number;
}

const parseMessages = (snapshot: DataSnapshot): Message[] => {
  if (!snapshot) return [];
  const val = snapshot.val();
  if (!val) return [];
  const messages = Object.values(val);
  return messages as Message[];
};

const HomePage = () => {
  const dbRef = ref(db);
  const [user] = useAuthState(auth);
  const [signOut, loading] = useSignOut(auth);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [messages, setMessages] = useState<Message[]>([]);
  useSetAnalytics();

  const onSignOut = async () => {
    if (!loading) await signOut();
  };

  const fetchMessages = async () => {
    if (!user) return;

    get(child(dbRef, `/messages/${dayjs().format('DD-MM-YYYY')}`))
      .then((s) => {
        const m = parseMessages(s);
        setMessages(m);
      })
      .catch((err) => {
        console.log('error fetching messages', err);
      });
  };

  const listenMessagesChanges = () => {
    onValue(child(dbRef, `/messages/${dayjs().format('DD-MM-YYYY')}`), (s) => {
      const m = parseMessages(s);
      setMessages(m);
    });
  };

  const uploadMessage = useCallback(async (message: Message) => {
    push(ref(db, `messages/${dayjs().format('DD-MM-YYYY')}`), message);
  }, []);

  useEffect(() => {
    fetchMessages();
    listenMessagesChanges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, user]);

  if (!user) {
    return <LoginButton />;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto space-y-8 home-page-container">
        <button
          className="bg-red-600 text-white px-4 py-2 rounded-sm disabled:opacity-50 place-self-end"
          onClick={onSignOut}>
          Logout
        </button>
        <MessageHistory
          selectedDate={selectedDate}
          onDateChange={setSelectedDate}
          messages={messages}
          isAdmin={user.email === 'mehul.ajmer97@gmail.com'}
        />
        <MessageInput
          userId={user.uid}
          userEmail={user.email || ''}
          uploadMessage={uploadMessage}
        />
      </div>
      <p className="text-sm text-gray-300">
        Note- This webpage or the information of this webpage cannot be used in
        any place, or cannot be shared with anyone without the owner's consent
      </p>
    </div>
  );
};

export default HomePage;
